import { SubscriptionsApi } from "api/subscriptionsApi";
import { Dispatch, SetStateAction } from "react";
import { isTodayExpiryDate, isBeforeExpiryDate } from "../../subscriptionOptions/renewalDates";

type Props = {
  autoRenewCancelDetails: autoRenewCancelDetailsProps[];
  getDashboardListInfo: any;
  setError: Dispatch<SetStateAction<string>>;  
};

type autoRenewCancelDetailsProps = {
  subject: string;
  accountPackageID: number;
  renewalDays: number | null;
  isFreeTrial: boolean;
  autoRenew: boolean;
  renewalDate: string | null;
};

const AutoRenewalCancelBanner: React.FC<Props> = ({
  autoRenewCancelDetails,
  getDashboardListInfo,
  setError,  
}) => {

  const enableAutoRenewSub = async (
    accountPackageID: number
  ) => {
    setError('');

    const result = await SubscriptionsApi.autoRenewSubscription(accountPackageID, true);

    if (result.data) {
      if (result.data.status === "1"){
        getDashboardListInfo();
      } else {
        setError('An error occurred, please try again.');
      }
    }

    if (result.error) {
      setError('An error occurred, please try again.');
    }
  };
  
  return (
    <>
      {autoRenewCancelDetails.map((item: autoRenewCancelDetailsProps) => {
        if(
          (
            item.renewalDays !== null && 
            item.renewalDays < 21 && 
            item.isFreeTrial !== true &&
            (item.renewalDate && (isTodayExpiryDate(item.renewalDate) || !isBeforeExpiryDate(item.renewalDate)))
          )
        ){
          return (
            <div className="SubscriptionRenewalBannerContainer">
              <div className="SubscriptionRenewalBanner WidthContent">
                <span>You have chosen to cancel auto-renew for your '{item.subject}' subscription. Having second thoughts? Turn auto-renew back on to keep your discount.</span>

                <button
                  onClick={() => enableAutoRenewSub(item.accountPackageID)}
                  className="Btn BtnOrange TileButton SlimButton FullWidthMob"
                >
                  Turn auto-renew on
                </button>
              </div>         
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};

export default AutoRenewalCancelBanner;
